import config from '@/config'

const whitelistedOrigins = (config.authWhitelistedExtensions || '')
  .split(',')
  .map((id) => id.trim())
  .filter(Boolean)
  .map((id) => `chrome-extension://${id}`)

const ancestors = location.ancestorOrigins || []

export const illegallyEmbedded =
  !('Cypress' in window) && ancestors.length > 0 && !whitelistedOrigins.includes(ancestors[0])

if (ancestors.length && !illegallyEmbedded) {
  config.embeddedRuntime = true
}
